import { Fragment, useState } from "react"
import * as Icons from "@nova/component-icons"
import { LegendDefinition } from "./types"
import type { MapBackgroundViewType } from "../control/useMapStyles"
import { useVisibleLegendDefinitions } from "./useVisibleLegendDefinitions"

const LegendItem = ({ definition }: { definition: LegendDefinition }) => {
    const { title, labels, Visual } = definition
    return (
        <div className="flex flex-col">
            <small className="block text-gray-0 leading-[18px] pb-2">{title}</small>
            <Visual />
            <div className="flex flex-row justify-between mt-2">
                {labels.map((label, i) => (
                    <small key={i} className="mono text-gray-200">
                        {label}
                    </small>
                ))}
            </div>
        </div>
    )
}

export const MapLegend = ({ viewType }: { viewType: MapBackgroundViewType }) => {
    const [isCollapsed, setIsCollapsed] = useState(false)
    const visibleDefinitions = useVisibleLegendDefinitions(viewType)

    if (!visibleDefinitions.length) return null

    return (
        <div className="w-[270px] rounded-[6px] bg-black-800 pointer-events-auto">
            <div
                className="group flex justify-between items-center px-3 cursor-pointer"
                style={{ height: 44 }}
                onClick={() => setIsCollapsed((prev) => !prev)}
            >
                <small className="h5 text-gray-0 select-none">Map Legend</small>
                <Icons.SmallIcon
                    Icon={isCollapsed ? Icons.Plus : Icons.Minus}
                    className="text-gray-100 group-hover:text-white"
                />
            </div>
            {!isCollapsed && (
                <div className="map-legend-scrollbar flex flex-col gap-3 px-3 pb-3 max-h-[360px] overflow-y-auto">
                    {visibleDefinitions.map((definition, i) => (
                        <Fragment key={definition.id}>
                            {i > 0 && <div className="h-px w-full bg-gray-700" />}
                            <LegendItem definition={definition} />
                        </Fragment>
                    ))}
                </div>
            )}
        </div>
    )
}
